webpackJsonp([17032855223779],{

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-bottom: ', ';\n'], ['\n  padding-bottom: ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _H = __webpack_require__(30);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _reactIntl = __webpack_require__(7);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _JobDates = __webpack_require__(171);
	
	var _JobDates2 = _interopRequireDefault(_JobDates);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Technologies = __webpack_require__(63);
	
	var _Technologies2 = _interopRequireDefault(_Technologies);
	
	var _Projects = __webpack_require__(454);
	
	var _Projects2 = _interopRequireDefault(_Projects);
	
	var _ResumeContainer = __webpack_require__(26);
	
	var _ResumeContainer2 = _interopRequireDefault(_ResumeContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Header = _styledComponents2.default.header(_templateObject, function (_ref) {
	  var theme = _ref.theme;
	  return theme.scale(1);
	});
	
	var getBreadCrumb = function getBreadCrumb(langKey) {
	  return [{
	    link: '/' + langKey + '/resume/jobs-and-clients/',
	    label: 'resume.jobsAndClients'
	  }];
	};
	
	var Job = function Job(props) {
	  var job = props.pathContext.job;
	  var menu = props.data.site.siteMetadata.resume.menu;
	
	
	  var description = job.description;
	  var langKey = props.intl.locale;
	
	  return _react2.default.createElement(
	    _ResumeContainer2.default,
	    {
	      menu: menu,
	      selectedPage: '/resume/jobs-and-clients/',
	      breadCrumb: getBreadCrumb(langKey)
	    },
	    _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: 'resume' },
	      function (resume) {
	        return _react2.default.createElement(_reactHelmet2.default, {
	          title: resume + ' - ' + job.name,
	          meta: [{ name: 'description', content: description }]
	        });
	      }
	    ),
	    _react2.default.createElement(
	      Header,
	      null,
	      _react2.default.createElement(
	        _H2.default,
	        null,
	        job.name
	      )
	    ),
	    _react2.default.createElement(_JobDates2.default, job.date),
	    _react2.default.createElement(_Projects2.default, {
	      projects: job.projects,
	      langKey: langKey,
	      job: job
	    }),
	    _react2.default.createElement(_Technologies2.default, { technologies: job.technologies })
	  );
	};
	
	Job.propTypes = {
	  intl: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.shape({
	    job: _propTypes2.default.shape({
	      name: _propTypes2.default.string,
	      description: _propTypes2.default.string,
	      date: _propTypes2.default.shape({
	        start: _propTypes2.default.string,
	        end: _propTypes2.default.string
	      }),
	      projects: _propTypes2.default.array,
	      technologies: _propTypes2.default.array
	    })
	  }).isRequired,
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(Job);
	module.exports = exports['default'];

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-bottom: ', ';\n'], ['\n  padding-bottom: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['  \n  padding-top: ', ';\n  padding-bottom: ', ';\n  display: block;\n'], ['  \n  padding-top: ', ';\n  padding-bottom: ', ';\n  display: block;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _H = __webpack_require__(27);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _reactIntl = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Link = __webpack_require__(28);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _getJobUrl = __webpack_require__(173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Header = _styledComponents2.default.header(_templateObject, function (_ref) {
	  var theme = _ref.theme;
	  return theme.scale(1);
	});
	
	var Li = _styledComponents2.default.li(_templateObject2, function (_ref2) {
	  var theme = _ref2.theme;
	  return theme.scale(-2);
	}, function (_ref3) {
	  var theme = _ref3.theme;
	  return theme.scale(-2);
	});
	
	var Projects = function Projects(_ref4) {
	  var projects = _ref4.projects,
	      job = _ref4.job,
	      langKey = _ref4.langKey;
	
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      Header,
	      null,
	      _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'resume.jobsAndClients.projects' },
	        function (txt) {
	          return _react2.default.createElement(
	            _H2.default,
	            null,
	            txt
	          );
	        }
	      )
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      projects.map(function (project) {
	        return _react2.default.createElement(
	          Li,
	          null,
	          _react2.default.createElement(
	            _Link2.default,
	            { to: (0, _getJobUrl.getJobUrl)(langKey, job.slug, project.slug) },
	            project.name
	          )
	        );
	      })
	    )
	  );
	};
	
	Projects.propTypes = {
	  projects: _propTypes2.default.array.isRequired,
	  job: _propTypes2.default.shape({
	    slug: _propTypes2.default.string.isRequired
	  }).isRequired,
	  langKey: _propTypes2.default.string.isRequired
	};
	
	exports.default = Projects;
	module.exports = exports['default'];

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _JobPage = __webpack_require__(452);
	
	var _JobPage2 = _interopRequireDefault(_JobPage);
	
	var _graphql = __webpack_require__(13);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobRoute = function JobRoute(props) {
	  return _react2.default.createElement(_JobPage2.default, props);
	};
	
	exports.default = JobRoute;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-resume-job-js-f2b7c5020f32a2584496.js